import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ColumnDefinition } from 'src/app/dto/columnDefinition';
// import cssVars from 'css-vars-ponyfill';

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent implements OnInit {

  @Input() displayedColumns: ColumnDefinition[];

  @Input() tableData: Object[] = [];

  @Input() initSortColumn: number;

  @Input() initSortDirection: string;

  @Input() selectable: boolean;

  @Input() selection: SelectionModel<any>;

  @Input() offset: number;

  @Input() take: number;

  @Input() component : any;

  @Input() height : string;
  
  dataSource = new MatTableDataSource(this.tableData);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  columns: string[];

  // selection = new SelectionModel<any>(true, []);

  ngOnInit() {
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent)
    if (this.height && !isIEOrEdge) {
      document.documentElement.style.setProperty('--table-height', this.height);
    }
    this.columns = this.displayedColumns.map(x => x.columnDef);
    if (this.selectable) { 
      this.columns.unshift('select');
    }
    this.dataSource.sort = this.sort;
  }

  sortData(sort: Sort) {
    if (this.component && this.component.onSort) {
      this.component.onSort(sort.active, sort.direction); 
    } else {
      var data = this.tableData.slice();
      const isAsc = sort.direction === 'asc';
      this.tableData = data.sort((a, b) => {
        return compare(a[sort.active], b[sort.active], isAsc);
      })
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    }
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    var result = true;
    this.tableData.forEach(row => {
      if (this.selection.isSelected(row) == false) {
        result = false;
      } 
    })
    return result;
  }
  
  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.tableData.forEach(row => this.selection.deselect(row));
    } else {
      this.tableData.forEach(row => this.selection.select(row));
    }
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  @debounce()
  onTableScroll(e) {
    const tableViewHeight = e.target.offsetHeight // viewport: ~500px
    const tableScrollHeight = e.target.scrollHeight // length of all table
    const scrollLocation = e.target.scrollTop; // how far user scrolled
    
    // If the user has scrolled within 200px of the bottom, add more data
    const buffer = 75;
    const limit = tableScrollHeight - tableViewHeight - buffer;
    if (this.component && scrollLocation > limit) {
      this.component.onScroll(e);
    }
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

export function debounce(delay: number = 300): MethodDecorator {
  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    const timeoutKey = Symbol();

    const original = descriptor.value;

    descriptor.value = function (...args) {
      clearTimeout(this[timeoutKey]);
      this[timeoutKey] = setTimeout(() => original.apply(this, args), delay);
    };

    return descriptor;
  };
}
